module.exports = __webpack_public_path__ + "static/9-318d377bbaa47dc1327e291b299e0a18.jpg";